import type { V2CustomDomainRouter } from "replo-publisher/src/trpc/routers/v2CustomDomain";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: v2CustomDomainRouter,
  client: v2CustomDomainClient,
  utils: v2CustomDomainUtils,
  options: v2CustomDomainOptions,
} = createTrpcRouterConfig<V2CustomDomainRouter>({
  path: "v2CustomDomain",
  queryClient: getNamespacedQueryClient("v2CustomDomain"),
});

export {
  v2CustomDomainClient,
  v2CustomDomainRouter,
  v2CustomDomainUtils,
  v2CustomDomainOptions,
};
